import { faCheck, faCircleExclamation, faNoteSticky, faTriangleExclamation, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { QUESTION_RESULT_STATUSES } from "models";

type QuestionResultStatusProps = {
  status?: QUESTION_RESULT_STATUSES;
};

export const QuestionResultStatus = ({ status }: QuestionResultStatusProps) => {
  if (status === undefined) return null;

  switch (status) {
    case QUESTION_RESULT_STATUSES.OK:
      return <FontAwesomeIcon icon={faCheck} className="QuestionResults-question-result-ok" />;
    case QUESTION_RESULT_STATUSES.OKWithRemarks:
      return <FontAwesomeIcon icon={faNoteSticky} className="QuestionResults-question-result-ok-with-remarks" />;
    case QUESTION_RESULT_STATUSES.Advice:
      return <FontAwesomeIcon icon={faTriangleExclamation} color="orange" />;
    case QUESTION_RESULT_STATUSES.Necessary:
      return <FontAwesomeIcon icon={faCircleExclamation} color="red" />;
    default:
      return <FontAwesomeIcon icon={faXmark} color="grey" />;
  }
};
